<h1>Why are you here</h1>
<a href="/">click here to go back to the place you should properly be.</a>